import { jsx as e } from "react/jsx-runtime";
const l = () => /* @__PURE__ */ e(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.25C6.64344 1.25 3.25 5.03039 3.25 10.5C3.25 13.9229 6.44554 20.6364 12 22.7498C17.5545 20.6364 20.75 13.9228 20.75 10.5C20.75 5.03039 17.3566 1.25 12 1.25ZM15 9C15 10.6569 13.6569 12 12 12C10.3431 12 9 10.6569 9 9C9 7.34315 10.3431 6 12 6C13.6569 6 15 7.34315 15 9Z",
    fill: "currentColor"
  }
);
export {
  l as default
};
